import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MaterialSvgIconFactory from '../../icons/MaterialSvgIconFactory';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {activePageDrawerOption, inactivePageDrawerOption} from './styles/mobileStyle';

const styles = {
    root: {
        flexGrow: 1,
    },
};

class DrawerOptionListItems extends React.Component {

    constructor(props) {
        super(props)
    }

    render() {
        const { classes } = this.props;

        return (
            <div>
                <ListItem button style={this.props.activePage.toLowerCase() === 'home' ? activePageDrawerOption : inactivePageDrawerOption}>
                    <ListItemIcon>
                        <MaterialSvgIconFactory iconName='home' />
                    </ListItemIcon>
                    <ListItemText primary="Home" onClick={event => {this.props.optionClicked('Home',0)}}/>
                </ListItem>
                <ListItem button style={this.props.activePage.toLowerCase() === 'undergraduate' ? activePageDrawerOption : inactivePageDrawerOption}>
                    <ListItemIcon>
                        <MaterialSvgIconFactory iconName='story' />
                    </ListItemIcon>
                    <ListItemText primary="Undergraduate" onClick={event => {this.props.optionClicked('Undergraduate',1)}}/>
                </ListItem>
                <ListItem button style={this.props.activePage.toLowerCase() === 'graduate' ? activePageDrawerOption : inactivePageDrawerOption}>
                    <ListItemIcon>
                        <MaterialSvgIconFactory iconName='school' />
                    </ListItemIcon>
                    <ListItemText primary="Graduate" onClick={event => {this.props.optionClicked('Graduate',2)}}/>
                </ListItem>
                <ListItem button style={this.props.activePage.toLowerCase() === 'projects' ? activePageDrawerOption : inactivePageDrawerOption}>
                    <ListItemIcon>
                        <MaterialSvgIconFactory iconName='work' />
                    </ListItemIcon>
                    <ListItemText primary="Projects" onClick={event => {this.props.optionClicked('Projects',3)}}/>
                </ListItem>
                <ListItem button style={this.props.activePage.toLowerCase() === 'about me' ? activePageDrawerOption : inactivePageDrawerOption}>
                    <ListItemIcon>
                        <MaterialSvgIconFactory iconName='person' />
                    </ListItemIcon>
                    <ListItemText primary="About Me" onClick={event => {this.props.optionClicked('About Me',4)}}/>
                </ListItem>
            </div>
        );
    }
}

DrawerOptionListItems.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DrawerOptionListItems);







// WEBPACK FOOTER //
// ./src/tabs/appBars/tileData.js